<section class="centered-fullwidth pb-16 pt-2">
  @if (isExtendedSearch()) {
    <div class="mb-10 mt-4">{{ data.fallbackSuggestions }}</div>
  }
  <div class="grid h-auto grid-cols-1 gap-y-5 desk:grid-cols-2 desk:gap-x-3">
    @for (kitchen of kitchens(); track kitchen.id; let index = $index) {
      @if (itemsToInsert.has(index)) {
        @let item = itemsToInsert.get(index)!;
        @if (item | isListingModelesText) {
          <div class="flex items-center px-5 py-12 desk:px-12">
            <app-title [title]="{ text: item.text, as: 'span' }" size="h1" />
          </div>
        }
        @if (item | isListingModelesVideo) {
          <div class="flex items-center justify-center">
            <div class="mx-5 h-[528px] w-full overflow-hidden rounded-3xl desk:h-[572px] desk:w-[340px]">
              <app-video [autoplay]="true" [video]="item.video" />
            </div>
          </div>
        }
      }
      @let gtmCard = data.gtmConfigItems;
      <app-kitchen-model-card
        (onCardSelected)="
          emitGtmEvent({
            event: gtmCard?.event,
            group: gtmCard?.group,
            description: gtmCard?.description,
            context: gtmCard?.context,
            event_type: 'click',
          })
        "
        (viewportObserver)="onReviewViewportEnter($event, kitchen.id)"
        [kitchen]="kitchen" />
    }
  </div>
</section>
